import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormHelperText from '@mui/material/FormHelperText'
import Switch from '@mui/material/Switch'
import React, { useContext } from 'react'
import { Context } from '../context'
import { AnyObject, ContextValue, EditableFieldsOfType } from '../types'

/**
 * Checkbox / switch field.
 */
export const DataEditContextCheckField = <T extends AnyObject>({
  field,
  type,
  customLabel,
  testId,
  ...rest
}: {
  field: EditableFieldsOfType<T, boolean>
  type?: string
  customLabel?: string
} & Omit<Record<string, unknown>, 'onChange' | 'value' | 'error' | 'name'>) => {
  const { flatData, errors, disabled, setFields, localeBase, t } = useContext<ContextValue<T>>(Context)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked
    setFields({ [field]: newValue })
  }

  const value = flatData[field] as unknown as boolean
  const error = errors[field]
  const resolvedTestId =
    testId ?? ((rest?.id as string | undefined) ? `check-field-${rest.id as string}` : `check-field-${field}`)

  return (
    <>
      <FormControlLabel
        control={
          type === 'switch' ? (
            <Switch
              onChange={handleChange}
              checked={value}
              disabled={disabled[field]}
              data-testid={resolvedTestId}
              {...rest}
            />
          ) : (
            <Checkbox
              onChange={handleChange}
              checked={value}
              disabled={disabled[field]}
              data-testid={resolvedTestId}
              style={{ zIndex: 0 }}
              {...rest}
            />
          )
        }
        label={t(customLabel ? `${localeBase}.${customLabel}` : `${localeBase}.${field}`)}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </>
  )
}

/**
 * Visibility field (internal / network checkbox).
 */
